import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { OtaApiService } from '../CommonController/ota-api-service';

@Component({
  selector: 'app-ota-batch-page',
  templateUrl: './ota-batch-page.component.html',
  styleUrls: ['./ota-batch-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    DatePipe,
  ],
})
export class OtaBatchPageComponent implements OnInit {
  pageSize = 10;
  currentPage = 1;
  looparray = [];
  listOfBatch = [];
  totalItems = 0;
  userPermissions = [];
  deleteOta = true;
  viewOta = true;
  createOta = true;
  updateOta = true;

  searchField = '';

  constructor(
    public otaApiService: OtaApiService,
    public commonApiService: CommonApiService,
    public router: Router,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.fetchBatchList();
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Ota' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Ota' && element.view === true) {
        this.viewOta = true;
      }
      if (element.pageName === 'Ota' && element.create === false) {
        this.createOta = false;
      }
      if (element.pageName === 'Ota' && element.update === false) {
        this.updateOta = false;
      }
      if (element.pageName === 'Ota' && element.delete === false) {
        this.deleteOta = false;
      }
    });
  }

  showBatchDetails(e, batchDetails) {
    this.router.navigate(['/ota-batch-view', batchDetails.id]);
  }

  abortOtaBatch(id) {
    if (confirm('Are you sure to Abort Batch')) {
      this.spinner.show();
      this.otaApiService.abortOtaBatch(id).subscribe({
        next: (res) => {
          try {
            if (res.status) {
              this.spinner.hide();
              this.commonApiService.openSnackbar(res.message);
            }
          } catch (error) {
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
          }
        },
        error: (err) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
        complete: () => {
          this.ngOnInit();
        },
      });
    }
  }

  fetchBatchList() {
    this.spinner.show();
    this.otaApiService
      .getOTABatchList(this.currentPage - 1, this.pageSize, this.searchField)
      .subscribe({
        next: (res) => {
          try {
            if (res.status) {
              this.spinner.hide();
              this.listOfBatch = res.data;
              this.totalItems = res.totalItems;
              this.commonApiService.openSnackbar(res.message);
            }
          } catch (error) {
            this.listOfBatch = [];
            this.spinner.hide();
            this.commonApiService.openSnackbar(
              error.error.message ||
                'An error occurred while processing the data.'
            );
          }
        },
        error: (err) => {
          this.listOfBatch = [];
          this.spinner.hide();
          this.commonApiService.openSnackbar(err.error.message);
        },
        complete: () => {
          this.spinner.hide();
        },
      });
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchBatchList();
  }

  onSizeChange(pageSize): void {
    this.pageSize = pageSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchBatchList();
  }

  onSearch(event) {
    this.currentPage = 1;
    this.searchField = event;
    this.fetchBatchList();
  }

  navigateBack() {
    this.commonApiService.back();
  }

  downloadBatchDetails(batchId) {
    if (confirm('Are You Sure?')) {
      this.spinner.show();
      this.otaApiService
        .fetchOtaBatchdetails(batchId, '', '', 1, 1000)
        .subscribe({
          next: (res) => {
            try {
              if (res.status) {
                this.spinner.hide();
                this.looparray = res.data.deviceDetails;
                this.exportToFile(res.data, this.looparray);
              }
            } catch (error) {
              this.spinner.hide();
              this.commonApiService.openSnackbar(
                error.error.message ||
                  'An error occurred while processing the data.'
              );
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.commonApiService.openSnackbar(err.error.message);
          },
        });
    }
  }

  // Helper function to format date
  formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Helper function to format time
  formatTime(dateString) {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  batchList;
  private exportToFile(otaBatchDetails, deviceData) {
    this.batchList = [];
    deviceData.forEach((element) => {
      this.batchList.push({
        BATCH_ID: otaBatchDetails.id,
        BATCH_NAME: otaBatchDetails.name,
        BATCH_DESC: otaBatchDetails.description,
        UIN: element['uin'],
        IMEI: element['imei'],
        OTA_Triggered: element['command'],
        OTA_RESPONSE: element['commandRes'],
        REMARK: element['otaMsg'],
        OTA_STATUS: element['otaStatus'],
      });
    });
    this.commonApiService.createCSVFile(this.batchList, 'Ota_Batch_export');
  }

  navigateTo(path) {
    this.router.navigate([path]);
  }

  openManualOtaPage() {
    sessionStorage.setItem('manualotaimei', '');
    this.router.navigate(['/manual-ota']);
  }
}
